import { createSlice } from '@reduxjs/toolkit';

interface ISuperAdminStats {
  show: boolean;
}
const initialState: ISuperAdminStats = {
  show: true,
};
export const superAdminStatsSlice = createSlice({
  name: 'superAdminStats',
  initialState,
  reducers: {
    toggleSuperAdminDrawer: (state: ISuperAdminStats, action) => {
      state.show = action.payload;
    },
  },
});

export const { toggleSuperAdminDrawer } = superAdminStatsSlice.actions;

export default superAdminStatsSlice.reducer;
